import { render } from "./resetpassword.vue?vue&type=template&id=a6e935a4"
import script from "./resetpassword.vue?vue&type=script&lang=js"
export * from "./resetpassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__